// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LayoutBg__Wrapper_eAiUF"};